// extracted by mini-css-extract-plugin
export default {"eligibility":"um-z"};